import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useT } from '../i18n.js';
/** Score a query against a label: substring, then word initials. */
export function matchScore(label, query) {
    const l = label.toLocaleLowerCase();
    const q = query.trim().toLocaleLowerCase();
    if (!q)
        return 1;
    const i = l.indexOf(q);
    if (i >= 0)
        return 100 - i;
    const initials = l
        .split(/[\s:/()-]+/)
        .filter(Boolean)
        .map((w) => w[0])
        .join('');
    return initials.includes(q) ? 10 : 0;
}
/** Modal command search (Mod+K). Arrow keys move, Enter runs, Escape closes. */
export function CommandPalette(props) {
    const t = useT();
    const [q, setQ] = useState('');
    const [index, setIndex] = useState(0);
    const input = useRef(null);
    const results = useMemo(() => props.actions
        .map((a) => ({ a, s: matchScore(a.label, q) }))
        .filter((x) => x.s > 0)
        .sort((x, y) => y.s - x.s)
        .map((x) => x.a), [props.actions, q]);
    useEffect(() => {
        const prev = document.activeElement;
        input.current?.focus();
        return () => prev?.focus?.();
    }, []);
    const run = (a) => {
        if (!a)
            return;
        props.onClose();
        void a.run();
    };
    return (_jsx("div", { className: "dl-dialog-backdrop", children: _jsxs("div", { className: "dl-dialog", role: "dialog", "aria-modal": "true", "aria-label": t('menu.commands'), children: [_jsx("input", { ref: input, className: "dl-input", role: "combobox", "aria-expanded": "true", "aria-controls": "dl-palette-list", "aria-activedescendant": results[index] ? `dl-cmd-${results[index].id}` : undefined, placeholder: t('palette.placeholder'), value: q, onChange: (e) => {
                        setQ(e.target.value);
                        setIndex(0);
                    }, onKeyDown: (e) => {
                        if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            setIndex((i) => Math.min(results.length - 1, i + 1));
                        }
                        else if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            setIndex((i) => Math.max(0, i - 1));
                        }
                        else if (e.key === 'Enter') {
                            e.preventDefault();
                            run(results[index]);
                        }
                        else if (e.key === 'Escape') {
                            e.preventDefault();
                            props.onClose();
                        }
                        else if (e.key === 'Tab') {
                            e.preventDefault();
                        }
                    } }), results.length === 0 ? (_jsx("p", { className: "dl-muted", children: t('palette.empty') })) : (_jsx("div", { id: "dl-palette-list", className: "dl-palette-list", role: "listbox", "aria-label": t('menu.commands'), children: results.map((a, i) => (_jsxs("div", { id: `dl-cmd-${a.id}`, role: "option", tabIndex: -1, "aria-selected": i === index, onMouseEnter: () => setIndex(i), onClick: () => run(a), onKeyDown: (e) => {
                            if (e.key === 'Enter')
                                run(a);
                        }, children: [_jsx("span", { children: a.label }), a.shortcut && _jsx("span", { className: "dl-kbd", children: a.shortcut })] }, a.id))) }))] }) }));
}
//# sourceMappingURL=CommandPalette.js.map